module.exports = __webpack_public_path__ + "static/shc2-3c6ae1415f19d6146112cd358494fa2a.png";